import script from "./vmsAffiliationGrid.vue?vue&type=script&lang=js"
export * from "./vmsAffiliationGrid.vue?vue&type=script&lang=js"

import "./vmsAffiliationGrid.vue?vue&type=style&index=0&id=dfdb28ba&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dfdb28ba"]])

export default __exports__